import React from 'react'
import './leadershipteam.scss'
const OurHistory = () => {
  // Reusable Component for each section block
  const TopicContentBlock = ({ title, children }) => (
    <div className="topicContentBlock">
      <div className="Heading">
        <h3>{title}</h3>
      </div>
      <div>{children}</div>
    </div>
  );

  return (
    <>
      <div className="leadership-main-wrapper">
        {/* Main Introduction */}
        <TopicContentBlock title="Meet the team">
          <p>Our board of directors is critical to the success of Sentry—and, in turn, you. Our board members bring unique and diverse backgrounds to the table. It’s experience you can trust to make the right decisions for Sentry. As a mutual company, our goal is always to do what’s right by you. And our board is right by us.</p>
          <ul className='team-list'>
            <li>Pete McPartland</li>
            <li>Graham Atkinson</li>
            <li>David Casper</li>
            <li>Larry Goodman</li>
            <li>Susan Morisato</li>
            <li>James Pearson</li>
            <li>Peter Pestillo</li>
            <li>Jean Regan</li>
            <li>Patricia Steinert</li>
          </ul>
        </TopicContentBlock>
      </div>
    </>
  )
}

export default OurHistory